import * as Style from './styles';
import * as StyleGlobal from '../../shared/GlobalStyles/styles';
import { useContext } from 'react';
import { DarkModeContext } from '../../contexts/darkMode';

export const Check = ({item, index, handleClick, keyName=''}) => {
    const {darkModeButton, selectedTheme, verifySisteShop} = useContext(DarkModeContext);

    return (
        <Style.CheckBox 
            onClick={()=> handleClick(item, index)}
            selected={item.marcado === 'S' || item[keyName ?? 'marcado'] ? true : false}
        >
        {
            item.marcado === 'S' || item[keyName ?? 'marcado']  ? (
                <StyleGlobal.IconChecked fill={darkModeButton ? verifySisteShop() : selectedTheme.backgrounds.red2}/>
            )
            :(
                null
            )
        }
        </Style.CheckBox>
    )

}